var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Variant=X"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 99706"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30112",
    x: 5,
    y: 17.7603,
    width: 18.0459,
    height: 1.74957,
    rx: 0.874784,
    transform: "rotate(-45 5 17.7603)",
    fill: "#F84B7A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30113",
    x: 17.875,
    y: 18.9998,
    width: 18.0459,
    height: 1.74957,
    rx: 0.874784,
    transform: "rotate(-135 17.875 18.9998)",
    fill: "#F84B7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardRedX);
export default __webpack_public_path__ + "static/media/credit-card-red-x.142a79bb90c2d8c323e19d446f078430.svg";
export { ForwardRef as ReactComponent };